import { render, staticRenderFns } from "./BrandsPage.vue?vue&type=template&id=4bf4656e&"
import script from "./BrandsPage.vue?vue&type=script&lang=ts&"
export * from "./BrandsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports